import { ErrorHandler } from '@angular/core';
import { Routes } from '@angular/router';

import { ApplicationErrorHandler } from './error-handler/error-handler';
import { errorGuard } from './error.guard';

export const ErrorRoutes: Routes = [
  {
    path: 'error',
    loadComponent: () =>
      import('./error-page/error-page.component').then(m => m.ErrorPageComponent),
    canDeactivate: [errorGuard]
  }
];

export const Error404Routes: Routes = [
  {
    path: 'error/404',
    loadComponent: () =>
      import('./error-404-page/error-404-page.component').then(m => m.Error404PageComponent),
    canDeactivate: [errorGuard]
  }
];

export const ErrorProviders = [
  {
    provide: ErrorHandler,
    useClass: ApplicationErrorHandler
  }
];
